export enum OttopilotColumnType {
    string = "92c0cad3-ae65-44ff-b92c-b6020b1f1758",
    uuid = "168ff406-867a-4aab-b742-8d324b63d8fe",
    uuidNullable = "1b72a508-5370-47dc-815f-1e4dc6cfda52",
    number = "4855103c-6ced-4b6c-99ac-0eeea62ef5de",
    boolean = "ee120813-56f1-4153-af08-504faf9065db",
    iso8601DateTime = "1ac7ce08-e298-44e3-b2b1-62f44ae8564a",
    iso8601Date = "03627882-20a7-4a5d-a9df-cf79d2ce35d2",
    iso8601Time = "63f3d96f-134e-4175-87a4-34c295b68c3a",
    array = "d24619df-0f8e-4b08-82bd-f5d01f46a6dc",
}
